export const Eighteen = 'J';